import { useNavigate } from "react-router-dom";
import { useTheme } from "../../../components/hooks/useTheme";
import { useState } from "react";
import { Tabs } from "../../../components/common/Tabs";
import { ReservationList } from "./ReservationList";
import colorConfigs from "../../../configs/colorConfigs";

const tabs = [
  {
    label: "All",
  },
  {
    label: "Today's Pickups",
  },
  {
    label: "Today's Returns",
  },
  {
    label: "Tomorrow's Pickups",
  },
  {
    label: "Tomorrow's Returns",
  },
  {
    label: "Rental",
  },
  {
    label: "Completed",
  },
  {
    label: "Cancelled",
  },
  {
    label: "Open",
  },
  {
    label: "Outstanding Payment",
  },
  {
    label: "No Show",
  },
]

const filterItems = [
  {
    id: 0,
    label: "Customer Name",
  },
  {
    id: 1,
    label: "Booking Number",
  },
]

export const Reservations = () => {
  const { themeStyles } = useTheme();
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const [activeTabLable, setActiveTabLable] = useState<string>("All");
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [searchValue, setSearchValue] = useState<string>("");
  const [reservationFilterValue, setReservationFilterValue] = useState(0);
  const [selectedFilter, setSelectedFilter] = useState<string>(filterItems[0].label);

  const hanbleTabChange = (index: number, tab: any) => {
    setActiveIndex(tab?.id || index);
    setCurrentIndex(index);
    setActiveTabLable(tab?.label);
    setSearchValue("");
    setSelectedFilter(filterItems[0].label);
    setReservationFilterValue(0);
    setPaginationModel({
      page: 0,
      pageSize: 10,
    })
  }

  return (
    <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
      <div className={`w-full ${themeStyles.main.tailwindMainBg} border ${themeStyles.main.borderColor} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
        <div className="flex items-center justify-end">
          <div className="flex items-center gap-2.5">
            <button className={`px-[8px] py-[6px] ${colorConfigs.btn.main.tailwind} rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
              onClick={() => navigate("/carrental/reservations/addreservation")}
            >
              <span className="material-symbols-outlined text-[25px] font-light">
                add
              </span>
              <span className="text-xs font-medium">Reservation</span>
            </button>

          </div>
        </div>
        <div className="w-full mt-4">
          <Tabs tabs={tabs} onChange={(index, tab) => hanbleTabChange(index, tab)} activeIndex={currentIndex} />
        </div>

        <div>
          <ReservationList
            activeIndex={activeIndex}
            activeTabLable={activeTabLable}
            paginationModel={paginationModel}
            setPaginationModel={setPaginationModel}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            reservationFilterValue={reservationFilterValue}
            setReservationFilterValue={setReservationFilterValue}
            selectedFilter={selectedFilter}
            setSelectedFilter={setSelectedFilter}
            filterItems={filterItems}
          />
        </div>
      </div>
    </div>
  )
}